"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = void 0;
// Important: this file is generated from the 'build' script and should not be
// edited directly
exports.version = '3.16.2';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/autolinker/dist/commonjs/version.js
// module id = 2983
// module chunks = 39